<template>
    <div id="tabs-inner-container">
        <div class="tab-container noselect">
            <ul>
                <li :class="`tab ${this.tab_class} noselect${this.tab == 'history' ? ' tab-active' : ''}`" v-on:click="changeTab('history')">
                    <a>{{'History'.toUpperCase()}}</a>
                </li>
                <li :class="`tab ${this.tab_class} noselect${this.tab == 'chat' ? ' tab-active' : ''}`" v-on:click="changeTab('chat')" v-if="state.is_chat">
                    <a>{{'Chat'.toUpperCase()}}</a>
                </li>
                <li :class="`tab ${this.tab_class} noselect${this.tab == 'player' ? ' tab-active' : ''}`" v-on:click="changeTab('player')" v-if="this.state.is_small">
                    <a>{{'Player'.toUpperCase()}}</a>
                </li>
            </ul>
            <div class="tab-settings noselect" :class="{'tab-active': this.tab == 'settings'}" v-on:click="changeTab('settings')">
                <a><i class="fa fa-cog"></i></a>
            </div>
        </div>
        <div class="widget-container">
            <game-history v-bind:state="state" v-bind:tab="tab"></game-history>
            <chat-history v-bind:state="state" v-bind:tab="tab"></chat-history>
            <player-container v-bind:state="state" v-bind:tab="tab" v-if="this.state.is_small && this.tab == 'player'"></player-container>
            <settings v-bind:state="state" v-bind:tab="tab"></settings>
        </div>
    </div>
</template>

<script>
    const GameHistory = require('./game-history.vue').default;
    const ChatHistory = require('./chat-history.vue').default;
    const PlayerContainer = require('./player-container.vue').default;
    const Settings = require('./settings.vue').default;

    export default {
        name: "tabs-selector",
        props: ['state'],
        components: {
            'game-history': GameHistory,
            'chat-history': ChatHistory,
            'player-container': PlayerContainer,
            'settings': Settings,
        },
        data: function()
        {
            return {
                utils: utils,
                tab: 'history', // history, chat, player, settings
                tab_class: 'col-2',
            };
        },
        created()
        {
            EventBus.$on('connected', this.onChange);
        },
        beforeDestroy()
        {
            EventBus.$off('connected', this.onChange);
        },
        mounted()
        {

        },
        beforeUpdate()
        {
            // console.log('tabs-selector before update');
            if (!this.state.is_small) {
                this.tab_class = 'col-2';
                if (this.tab == 'player') {
                    this.tab = 'history';
                }
            } else {
                this.tab_class = 'col-3';
            }
        },
        updated()
        {
            // console.log('tabs-selector updated');
        },
        methods: {
            onChange()
            {
                this.tab = this.state.display_active_controls_tab;
            },
            changeTab(tab)
            {
                this.tab = tab;
            },
            toggleDisplayChannels()
            {

            },
        }
    }
</script>

<style scoped>

</style>
